// src/components/GigPassport/constants/mockData.js
const hoursAgo = (hours) => new Date(Date.now() - hours * 60 * 60 * 1000);
const daysFromNow = (days) => {
  const date = new Date(Date.now() + days * 24 * 60 * 60 * 1000);
  return date.toISOString();
};

import { CITY_REGISTRY } from '../../../data/cityRegistry';

const ZONES = {
  montreal: 'Mile End / Saint-Denis / Quartier des Spectacles',
  nyc: 'Washington Heights · Lower East Side · Brooklyn',
  lehigh_valley: 'Historic Bethlehem / SteelStacks',
  rtm: 'House of Rastafari',
  laurentian: 'Boreal landscapes of Quebec & rural NY/NJ',
  rochester: 'East End / Downtown Rochester',
  birmingham: 'The Nick / Birmingham independent-room grid',
};

const WELCOME_MESSAGES = {
  montreal: 'your stage pass for the Montréal field signal across Mile End and Saint-Denis',
  nyc: 'your city-wide access pass for Washington Heights, Lower East Side, and Brooklyn live rooms',
  lehigh_valley: 'your VIP signal for the center of Musikfest',
  rtm: 'your VIP signal for the Yetibeb Moged Show & Rototom coverage',
  laurentian: 'your access pass for roadside field notes and ephemera',
  rochester: 'your access pass for the Rochester Fringe signal field',
  birmingham: "your access pass for Birmingham's folk n' roll field signal",
};

export const CITIES = Object.keys(CITY_REGISTRY).reduce((acc, key) => {
  const city = CITY_REGISTRY[key];
  acc[key] = {
    id: city.id,
    label: city.label,
    festival: city.festival,
    zone: ZONES[key] || '',
    welcomeMessage: WELCOME_MESSAGES[key] || '',
  };
  return acc;
}, {});

export const DEMO_MESSAGES = [
  { id: '1',  city: 'montreal', text: "Welcome to the Gig Passport — your stage pass for the Montréal field signal across Saint-Denis and Mile End.", user: "GigBot", role: "System", uid: "system", timestamp: hoursAgo(0.25), category: 'GENERAL_DISCUSSION' },
  { id: 'mtl-turbo-haus-1', city: 'montreal', text: "Final Live Band Karaoke at Turbo Haus tonight! 2040 Saint-Denis. Full band ready, sign-up sheet at the sound booth.", user: "Turbo Haus & Bily Kun", role: "Venue", uid: "venue-turbo-haus-montreal", timestamp: hoursAgo(0.8), category: 'GIG_OPPORTUNITY' },
  { id: 'mtl-lescogriffe-1', city: 'montreal', text: "Le lancement d'album « Le Reflet du Miroir » par béatitude et Le bon vent ce soir à l'Escogriffe (4461 Saint-Denis). Portes 20h00, spectacle 20h30. Une fresque de 37 minutes sans arrêt!", user: "Bar L'Escogriffe", role: "Venue", uid: "venue-lescogriffe-montreal", timestamp: hoursAgo(0.4), category: 'GIG_OPPORTUNITY' },
  { id: 'mtl-minute-mapp-1', city: 'montreal', text: "MINUTE_MAPP 2026 ce soir au Mile End! Plus de 60 créateurs projettent leurs œuvres de 60 secondes sur la façade de l'ancien Million Tapis et Tuiles face au skatepark Van Horne sous le thème CARREFOUR.", user: "MINUTE_MAPP", role: "Venue", uid: "venue-minute-mapp-montreal", timestamp: hoursAgo(0.2), category: 'GIG_OPPORTUNITY' },
  { id: 'mtl-moment-factory-1', city: 'montreal', text: "Moment Factory sound lab is running spatial acoustic tests on Jeanne-Mance. Multi-channel audio routing active across the Mile End corridor.", user: "Moment Factory", role: "Venue", uid: "venue-moment-factory-montreal", timestamp: hoursAgo(0.15), category: 'GIG_OPPORTUNITY' },
  { id: 'mtl-van-horne-1', city: 'montreal', text: "Van Horne Skatepark open session tonight with ambient electronic field captures echoing under the Rosemont-Van Horne viaduct.", user: "Van Horne Skatepark", role: "Venue", uid: "venue-van-horne-skatepark-montreal", timestamp: hoursAgo(0.3), category: 'GENERAL_DISCUSSION' },
  // ── NYC ──
  { id: 'nyc-pianos-dream-pop-1', city: 'nyc', text: "I Have A Dream Pop Festival at Pianos (158 Ludlow St): The Veldt (Daniel & Danny Chavis opening with 'Christine'), Diary (blood-red vinyl), Day & Dream, and Portland, Maine's Darksoft ('Everydayness') lighting up the Showroom.", user: "Pianos NYC", role: "Venue", uid: "venue-pianos-nyc", timestamp: hoursAgo(0.05), category: 'GIG_OPPORTUNITY' },
  { id: 'nyc-nomaa-dear-earth-1', city: 'nyc', text: "Opening reception at NoMAA Gallery (4140 Broadway at 176th St) for 'Dear Earth… Love, Uptown' — 29 Uptown artists and Paula Maria Persiani's 'Aquí Me Quedo — Los Cepeda' bridging Washington Heights and Loíza, Puerto Rico.", user: "NoMAA Gallery", role: "Venue", uid: "venue-nomaa-gallery-nyc", timestamp: hoursAgo(0.1), category: 'GENERAL_DISCUSSION' },
  { id: 'nyc-film-forum-1', city: 'nyc', text: "Riding the Brooklyn-bound A train from 125th Street down to West 4th for William Greaves's 'Once Upon A Time in Harlem' at Film Forum (209 West Houston St) — capturing the 1910 Clef Club origin of the word 'Gig' by James Reese Europe.", user: "Film Forum", role: "Venue", uid: "venue-film-forum-nyc", timestamp: hoursAgo(0.15), category: 'GENERAL_DISCUSSION' },
  { id: 'nyc-kismat-tue-1', city: 'nyc', text: "Tuesday Jazz Night at Kismat (603 Fort Washington Ave) is live from 8:00 to 11:00 PM with Gottfried Stöger on woodwinds and the Uptown Ensemble.", user: "Gottfried Stöger", role: "Artist", uid: "artist-gottfried-stoger", timestamp: hoursAgo(0.25), category: 'GIG_OPPORTUNITY' },
  { id: 'nyc-kismat-1', city: 'nyc', text: "Kismat is logging Tuesday Jazz Nights and Friday live music as one neighborhood performance layer — working musicians, show-tune duets, teachers, regulars, the whole uptown room.", user: "Kismat Washington Heights", role: "Venue", uid: "venue-kismat-washington-heights", timestamp: hoursAgo(0.35), category: 'GENERAL_DISCUSSION' },
  { id: 'nyc-victoria-miwi-1', city: 'nyc', text: "Miwi's Music Thing at Victoria NYC (235 Eldridge Street): Sunday catalog and songwriter sessions 4:30–7:00 PM with Miwi La Lupa, Monk Americana, and live field capture.", user: "Victoria NYC", role: "Venue", uid: "venue-victoria-nyc", timestamp: hoursAgo(0.6), category: 'GIG_OPPORTUNITY' },
  { id: 'nyc-monk-1', city: 'nyc', text: "Connecting the Uptown Friday room at Kismat with Sunday afternoon sessions at Victoria NYC on Eldridge Street. Same evergreen artist card tracks both rooms.", user: "Monk Americana", role: "Artist", uid: "monk-washington", timestamp: hoursAgo(0.8), category: 'COLLABORATION' },
  { id: 'nyc-kismat-2', city: 'nyc', text: "Five-minute interviews only tonight. Who are you playing with, what keeps you in small rooms, and what should people understand about live music up here?", user: "Uptown Field Crew", role: "Music Fan", uid: "fan-uptown-field-crew", timestamp: hoursAgo(0.9), category: 'COLLABORATION' },
  { id: 'nyc-sistagrrrl-1', city: 'nyc', text: "Tonight at 7:30 PM: Hosting Sista Grrrl co-founder Honeychild Coleman for a panel, open Q&A, and zine making! Bring your templates. @melophobe.bk #sistagrrrl", user: "Melophobe BK", role: "Venue", uid: "venue-melophobe-bk", timestamp: hoursAgo(1), category: 'GIG_OPPORTUNITY' },
  { id: 'nyc-sistagrrrl-2', city: 'nyc', text: "Stoked to discuss Sista Grrrl, doing DIY shows in the 90s, and the new wave of riot grrrl tonight. Bring a zine page you are proud of! #sistagrrrl", user: "Honeychild Coleman", role: "Artist", uid: "artist-honeychild-coleman", timestamp: hoursAgo(2), category: 'GENERAL_DISCUSSION' },
  { id: 'nyc-sistagrrrl-3', city: 'nyc', text: "Melophobe BK tonight for the Sista Grrrl meetup is going to be historic. Zine making is exactly the energy the neighborhood needs.", user: "Jerome Washington", role: "Music Fan", uid: "fan-jerome-washington", timestamp: hoursAgo(0.5), category: 'GENERAL_DISCUSSION' },
  // ── Rototom ──
  { id: 'rtm-1', city: 'rtm', text: "Respect! Welcome to the Rototom Sunsplash Signal. Connect with the Yetibeb Moged crew at the House of Rastafari stage.", user: "Girum", role: "Artist", uid: "artist-girum", timestamp: hoursAgo(0.5), category: 'GENERAL_DISCUSSION' },
  { id: 'rtm-2', city: 'rtm', text: "Join us tomorrow at House of Rastafari for the daily Yetibeb Moged Live Dub Sessions and roots drumming circles. Bring your instruments!", user: "House of Rastafari", role: "Venue", uid: "venue-house-of-rastafari", timestamp: hoursAgo(1.2), category: 'GIG_OPPORTUNITY' },
  { id: 'rtm-3', city: 'rtm', text: "Setting up the 16-channel analog desk and space echo delay at the stage. Ready for the live mix, dubplates are in the box.", user: "Yetibeb", role: "Artist", uid: "artist-yetibeb", timestamp: hoursAgo(2.1), category: 'COLLABORATION' },
  { id: 'rtm-4', city: 'rtm', text: "The Ethiopia-Spain roots corridor is sounding incredible this year. The vinyl archive at House of Rastafari is a must-visit.", user: "Selam", role: "Music Fan", uid: "fan-selam", timestamp: hoursAgo(3.8), category: 'GENERAL_DISCUSSION' },
  // ── Lehigh Valley ──
  { id: 'lv-1', city: 'lehigh_valley', text: "Welcome to the Bethlehem Musikfest Signal. Follow the signal trail across the SteelStacks and historic north side.", user: "GigBot", role: "System", uid: "system", timestamp: hoursAgo(0.5), category: 'GENERAL_DISCUSSION' },
  // ── Rochester ──
  { id: 'roc-1', city: 'rochester', text: 'Rochester Fringe field archive: Mister Aubs live at The Church (Downtown United Presbyterian Church: Hallock Lounge) on September 24, 2026.', user: 'GigBot', role: 'System', uid: 'system', timestamp: hoursAgo(0.5), category: 'GENERAL_DISCUSSION' },
  { id: 'roc-church-1', city: 'rochester', text: "Archiving Mister Aubs' September 24 Rochester Fringe performance with DK Keys and Anthony A.C. Collins in the Hallock Lounge at Downtown United Presbyterian Church.", user: "The Church (Hallock Lounge)", role: "Venue", uid: "venue-the-church-rochester", timestamp: hoursAgo(0.6), category: 'GIG_OPPORTUNITY' },
  { id: 'roc-aubs-1', city: 'rochester', text: "Thursday evening in the Hallock Lounge at The Church (121 N Fitzhugh St) — live vocals, grand piano songcraft, and collaborator trio session captured for the Rochester Fringe archive.", user: "Mister Aubs", role: "Artist", uid: "artist-mister-aubs", timestamp: hoursAgo(0.9), category: 'COLLABORATION' },
];

export const DEMO_ROLES = [
  {
    title: 'Venue Owner',
    icon: 'BusinessIcon',
    description: 'Post festival slots and connect with FIJM artists'
  },
  {
    title: 'Artist',
    icon: 'MusicNoteIcon',
    description: 'Pitch for festival stages and network with Montréal venues'
  },
  {
    title: 'Listener',
    icon: 'PersonIcon',
    description: 'Discover jazz artists and follow the FIJM schedule'
  }
];

// Personas keyed by role, then city.
export const PERSONAS_BY_ROLE = {
  'Venue Owner': [
    { id: 'venue-turbo-haus-montreal', city: 'montreal', name: 'Turbo Haus & Bily Kun', tagline: 'Saint-Denis underground room & Mont-Royal after-hours hub', tags: ['Saint-Denis', 'Live Music', 'Live Band Karaoke', 'Plateau'] },
    { id: 'venue-lescogriffe-montreal', city: 'montreal', name: "Bar L'Escogriffe", tagline: 'Saint-Denis indie-rock and progressive music bedrock', tags: ['Saint-Denis', 'Live Music', 'Album Launch', 'Plateau', 'Progressive Rock'] },
    { id: 'venue-minute-mapp-montreal', city: 'montreal', name: 'MINUTE_MAPP / Million Carpets', tagline: 'Mile End facade projection & Van Horne skatepark canvas', tags: ['Mile End', 'Projection Mapping', 'Van Horne', 'MAPP_MTL'] },
    { id: 'venue-kismat-washington-heights', city: 'nyc', name: 'Kismat Washington Heights', tagline: '603 Fort Washington Ave — Tuesday Jazz Night with Gottfried Stöger & Weekly Friday Live Music', tags: ['Washington Heights', 'Tuesday Jazz Night', 'Friday Live Music', 'Karaoke'] },
    { id: 'venue-pianos-nyc', city: 'nyc', name: 'Pianos (Lower East Side)', tagline: "158 Ludlow St — 'I Have A Dream Pop Festival' with The Veldt ('Christine'), Diary, Day & Dream & Darksoft", tags: ['Lower East Side', 'Pianos', 'I Have A Dream Pop Festival', 'The Veldt', 'Shoegaze'] },
    { id: 'venue-nomaa-gallery-nyc', city: 'nyc', name: 'NoMAA Gallery (Uptown)', tagline: "4140 Broadway (at 176th St) — 'Dear Earth… Love, Uptown' & Paula Maria Persiani's 'Aquí Me Quedo — Los Cepeda'", tags: ['Washington Heights', 'NoMAA Gallery', 'Paula Maria Persiani', 'Loíza', 'Aquí Me Quedo'] },
    { id: 'venue-film-forum-nyc', city: 'nyc', name: 'Film Forum & The A Train', tagline: "209 West Houston St — 'Once Upon A Time in Harlem' & the 1910 Clef Club Origin of 'Gig'", tags: ['West Village', 'Harlem Renaissance', 'Gig Lore', 'The A Train'] },
    { id: 'venue-victoria-nyc', city: 'nyc', name: 'Victoria NYC', tagline: "235 Eldridge Street — Miwi's Music Thing Sunday catalog sessions & live field capture", tags: ['Lower East Side', "Miwi's Music Thing", 'Live Music', 'Unsigned Node'], verificationStatus: 'unsigned', claimed: false },
    { id: 'venue-melophobe-bk', city: 'nyc', name: 'Melophobe BK', tagline: 'Brooklyn DIY space and indie hub — Sista Grrrl panel & community showcases', tags: ['Brooklyn', 'DIY Space', 'Live Music', 'Zine Making'] },
    { id: 'venue-steelstacks', city: 'lehigh_valley', name: 'SteelStacks',    tagline: 'Premier industrial-arts venue — 1500-cap festival hub',      tags: ['1500 Cap', 'Bethlehem', 'Musikfest'] },
    { id: 'venue-wind-creek',  city: 'lehigh_valley', name: 'Wind Creek',     tagline: 'Upscale event center — 3000-cap touring destination',        tags: ['3000 Cap', 'Lehigh Valley', 'Touring'] },
    { id: 'venue-house-of-rastafari', city: 'rtm', name: 'House of Rastafari', tagline: 'The spiritual and cultural heart of Rototom Sunsplash', tags: ['House of Rastafari', 'Cultural Hub', 'Yetibeb Moged'] },
    { id: 'venue-rototom-main', city: 'rtm', name: 'Rototom Main Stage', tagline: 'The massive main stage of Rototom Sunsplash — 30,000 cap', tags: ['Main Stage', 'Global Reggae', 'Outdoor Stage'] },
    { id: 'venue-the-church-rochester', city: 'rochester', name: 'The Church (Downtown United Presbyterian Church: Hallock Lounge)', tagline: '121 N Fitzhugh St — Rochester Fringe venue where Mister Aubs performed on Sep 24, 2026', tags: ['Rochester Fringe', 'Hallock Lounge', 'Mister Aubs', 'Live Performance'] },
    { id: 'venue-parcel-5', city: 'rochester', name: 'Parcel 5 (Rochester Fringe Grounds)', tagline: 'Downtown Rochester Fringe festival grounds & field walk telemetry', tags: ['Rochester Fringe', 'Outdoor Grounds', 'Downtown'] },
  ],
  'Artist': [
    { id: 'artist-beatitude',     city: 'montreal', name: 'béatitude',        tagline: 'Sherbrooke progressive rock quintet — « Le Reflet du Miroir »',       tags: ['Progressive Rock', 'Estrie', 'Album Launch', 'Quintet'] },
    { id: 'paula-maria-persiani', city: 'nyc',      name: 'Paula Maria Persiani', tagline: "Uptown / Nuyorican visual artist — 'Aquí Me Quedo — Los Cepeda' (Loíza, Puerto Rico) at NoMAA Gallery", tags: ['Nuyorican', 'Loíza', 'Aquí Me Quedo', 'Los Cepeda', 'NoMAA Gallery'] },
    { id: 'monk-washington',      city: 'nyc',      name: 'Monk Americana',   tagline: "Multi-instrumentalist & NYC street archivist — Pianos NYC ('I Have A Dream Pop Festival' w/ HoneyChild's DEM), Kismat & Victoria NYC", tags: ['Americana', 'Pianos NYC', 'Blues', 'Banjo', 'Post-Punk'] },
    { id: 'gottfried-stoger',     city: 'nyc',      name: 'Gottfried Stöger', tagline: 'Woodwinds, composition & global improvisation — Kismat Tuesday Jazz & Friday Resident', tags: ['Woodwinds', 'Jazz', 'Broadway', 'Kismat Resident'] },
    { id: 'artist-ed-marshall',    city: 'nyc',      name: 'Ed Marshall',      tagline: 'Photographer, videographer, & multimedia producer — Bronx-based photojournalist & musician',       tags: ['Photography', 'Videography', 'Multimedia', 'Street Photojournalism', 'Electronic Music', 'NYC'] },
    { id: 'artist-honeychild-coleman', city: 'nyc', name: 'Honeychild Coleman', tagline: "Singer-songwriter & guitarist — Sista Grrrl co-founder & HoneyChild's DEM w/ Monk Americana at Pianos NYC ('I Have A Dream Pop Festival')", tags: ['Guitarist', 'Vocalist', "HoneyChild's DEM", 'Pianos NYC', 'Sista Grrrl'] },
    { id: 'anansi-byte', city: 'nyc', name: 'Anansi Byte', tagline: 'The Ledger Guardian — cryptographic sound archivist and provenance keeper', tags: ['Provenance', 'Ledger', 'Live Code', 'Cryptographic', 'Sound Archival'] },
    { id: 'anansi-byte', city: 'lehigh_valley', name: 'Anansi Byte', tagline: 'The Ledger Guardian — cryptographic sound archivist and provenance keeper', tags: ['Provenance', 'Ledger', 'Live Code', 'Cryptographic', 'Sound Archival'] },
    { id: 'artist-girum', city: 'rtm', name: 'Girum', tagline: 'Guitarist & composer blending traditional Ethiopian melodies with classic reggae', tags: ['Guitarist', 'Composer', 'Roots Reggae'] },
    { id: 'artist-yetibeb', city: 'rtm', name: 'Yetibeb', tagline: 'Vocalist & sound system operator, live dub mix engineer', tags: ['Vocalist', 'Dub Engineer', 'Sound System'] },
    { id: 'artist-mister-aubs', city: 'rochester', name: 'Mister Aubs', tagline: 'Vocalist, songwriter & Rochester Fringe performer at The Church (Hallock Lounge, Sep 24, 2026)', tags: ['Rochester Fringe', 'The Church', 'Hallock Lounge', 'Live Trio'] },
    { id: 'azariah', city: 'rochester', name: 'Azariah (Darius Franklin)', tagline: 'Underground hip-hop lyricist & co-founder of Young Black And Gifted', tags: ['Boom-Bap', 'Lyricist', 'SFD', 'Rochester'] },
  ],
  'Music Fan': [
    { id: 'demo-music-fan',       city: 'montreal', name: 'Miriam Côté',       tagline: 'Jazz journalist & FIJM volunteer coordinator',                    tags: ['Press', 'Curator', 'Photographer'] },
    { id: 'fan-daniel-tremblay',  city: 'montreal', name: 'Daniel Tremblay',   tagline: '25 consecutive FIJM festivals — vinyl collector & historian',      tags: ['Audiophile', 'Historian', 'Season Pass'] },
    { id: 'fan-nadia-ouellet',    city: 'montreal', name: 'Nadia Ouellet',     tagline: 'Music teacher who brings student groups to FIJM every summer',    tags: ['Educator', 'Community Builder', 'FIJM Regular'] },
    { id: 'fan-sofia-reyes',      city: 'nyc',      name: 'Sofia Reyes',       tagline: 'Music blogger & tastemaker — Williamsburg underground circuit',   tags: ['Blogger', 'Tastemaker', 'LES Regular'] },
    { id: 'fan-jerome-washington',city: 'nyc',      name: 'Jerome Washington', tagline: 'Vinyl collector & open mic curator — Brooklyn/Harlem scene',       tags: ['Vinyl', 'Curator', 'Community'] },
    { id: 'fan-amara-singh',      city: 'nyc',      name: 'Amara Singh',       tagline: 'Music educator & Queens community organizer — jazz in schools',    tags: ['Educator', 'Organizer', 'Queens'] },
    { id: 'fan-selam', city: 'rtm', name: 'Selam', tagline: 'Cultural documentarian and reggae researcher', tags: ['Historian', 'Press', 'Reggae Reviewer'] },
    { id: 'fan-solomon', city: 'rtm', name: 'Solomon', tagline: 'Vinyl archivist, sound collector, and Sound System operator', tags: ['Vinyl', 'Selector', 'Dubplate Archivist'] },
    { id: 'fan-yared', city: 'rtm', name: 'Yared', tagline: 'Community organizer and Rototom volunteer coordinator', tags: ['Organizer', 'Volunteer', 'Rototom Regular'] },
    { id: 'fan-theo-grant', city: 'rochester', name: 'Theo Grant', tagline: 'Fringe route keeper and independent performance archivist', tags: ['Archivist', 'Fringe', 'Downtown'] },
    { id: 'fan-nia-wells', city: 'rochester', name: 'Nia Wells', tagline: 'East End listener tracking experimental stages', tags: ['Listener', 'East End', 'Experimental'] },
    { id: 'fan-olivia-chen', city: 'rochester', name: 'Olivia Chen', tagline: 'Festival volunteer mapping accessible performance routes', tags: ['Volunteer', 'Accessibility', 'Festival'] },
  ],
};

export const DEMO_PASSPORT_ENTRIES = [
  {
    id: 'passport-entry-mtl-1',
    title: 'TD Main Stage Residency Pitch',
    summary: 'Three-night residency proposal for the TD Stage at Place des Arts — submitted via Gig Passport pitch flow and accepted by FIJM programming.',
    collaborators: ['FIJM Programming', 'Black Star Signal'],
    tags: ['featured', 'fijm', 'main-stage'],
    contact: 'bookings@blackstarsignal.fm',
    timestamp: hoursAgo(4)
  },
  {
    id: 'passport-entry-mtl-2',
    title: 'L\'Astral Late-Night Jazz Fusion',
    summary: 'Four-act late-night showcase at L\'Astral co-produced with local promoters. Passport flow coordinated stage times, backline, and artist contracts.',
    collaborators: ["L'Astral Montréal", 'Kofi Asante Trio'],
    tags: ['fijm', 'jazz-fusion', 'indoor'],
    contact: 'production@astral-mtl.com',
    timestamp: hoursAgo(11)
  },
  {
    id: 'passport-entry-mtl-3',
    title: 'Place des Arts Free Stage Program',
    summary: 'Open-air programming slot secured for the free outdoor stage. Coordination of 8 emerging artists across 2 festival nights.',
    collaborators: ['Club Soda MTL', 'Miriam Côté Productions'],
    tags: ['featured', 'outdoor', 'emerging-artists', 'free-stage'],
    contact: 'outdoor@fijm.ca',
    timestamp: hoursAgo(20)
  }
];

const RAW_DEMO_EVENTS = [
  {
    id: 'event-turbo-haus-montreal',
    city: 'montreal',
    title: 'Live Band Karaoke Finale & Bily Kun Session',
    type: 'SHOWCASE',
    date: '2026-09-27T19:40:00-04:00',
    duration: 'Sunday, Sep 27, 2026 · 7:40 PM – 11:30 PM',
    venue: 'Turbo Haus & Bily Kun',
    capacity: 200,
    genres: ['Live Band Karaoke', 'Punk', 'Rock', 'Alternative'],
    description: 'Final edition of Live Band Karaoke on Saint-Denis followed by after-hours Czech pilsner & absinthe ritual on Mont-Royal.',
    requirements: 'Open sign-up at the sound booth.',
    compensation: 'Community gathering',
    applicationDeadline: null,
    status: 'PUBLISHED',
    createdBy: 'venue-turbo-haus-montreal',
    createdAt: '2026-09-27T19:40:00-04:00'
  },
  {
    id: 'event-beatitude-lescogriffe-montreal-2026-09-29',
    city: 'montreal',
    title: "Le lancement d'album: béatitude et Le bon vent",
    type: 'SHOWCASE',
    date: '2026-09-29T20:30:00-04:00',
    duration: 'Tuesday, Sep 29, 2026 · 8:30 PM – 11:30 PM',
    venue: "Bar L'Escogriffe",
    capacity: 150,
    genres: ['Progressive Rock', 'Quebec Prog', 'Poetry', 'Live Band'],
    description: "Lancement du premier album « Le Reflet du Miroir » — une grande chanson de 37 minutes divisée en sept parties, enregistrée sans arrêt dans la lignée d'Harmonium et Yes.",
    requirements: 'Portes 20h00, spectacle 20h30. Bar L\'Escogriffe, 4461 rue Saint-Denis.',
    compensation: 'Ticketed launch',
    applicationDeadline: null,
    status: 'PUBLISHED',
    createdBy: 'venue-lescogriffe-montreal',
    createdAt: '2026-09-29T20:30:00-04:00'
  },
  {
    id: 'event-minute-mapp-montreal-2026-10-01',
    city: 'montreal',
    title: 'MINUTE_MAPP 2026 Evening — CROSSROADS',
    type: 'SHOWCASE',
    date: '2026-10-01T17:00:00-04:00',
    duration: 'Thursday, Oct 1, 2026 · 5:00 PM – 10:00 PM',
    venue: 'Former Million Carpets and Tiles (Van Horne Skatepark)',
    capacity: 1000,
    genres: ['Projection Mapping', 'Digital Art', 'Electronic', 'Sound Design'],
    description: "60-second architectural mapping projections under the theme CROSSROADS on the iconic facade overlooking the Van Horne skatepark. Over 60 global creators.",
    requirements: 'Free admission · Registration required. Outdoor projection on Mile End facade.',
    compensation: "Jury Prize & People's Choice Award",
    applicationDeadline: null,
    status: 'PUBLISHED',
    createdBy: 'venue-minute-mapp-montreal',
    createdAt: '2026-10-01T17:00:00-04:00'
  },
  // ── NYC events ──
  {
    id: 'node-harlem-505-w147-studio',
    city: 'nyc',
    title: '503–505 West 147th Street (Coordinate 505 // Eugene L. Fitch & Levi P. Treadwell)',
    type: 'SHOWCASE',
    date: '2026-10-25T18:54:00-04:00',
    duration: 'Prime Node · 1854 Frequency Archival HQ',
    venue: '503–505 West 147th Street (Coordinate 505 // Eugene L. Fitch & Levi P. Treadwell)',
    venueId: 'node-harlem-505-w147-studio',
    address: '503–505 West 147th Street, Hamilton Heights / Sugar Hill, Harlem, NY 10031',
    latitude: 40.8267,
    longitude: -73.9472,
    capacity: 100,
    genres: ['Media Archaeology', 'Plato Clock (1902)', 'Twin-Lot Provenance', 'Harlem'],
    description:
      '503–505 West 147th Street twin-lot coordinate where horologist Eugene L. Fitch submerged his 1902 revolving brass Plato Clock inside a water-filled glass dome at No. 505 alongside railroad bridge builder Levi Penfield Treadwell at No. 503.',
    requirements: 'Archival coordinate at 503–505 West 147th Street, Harlem.',
    compensation: 'Prime Node · Coordinate 505',
    applicationDeadline: null,
    status: 'PUBLISHED',
    createdBy: 'node-harlem-505-w147-studio',
    featuredArtistName: 'Eugene L. Fitch (1902 Plato Clock) & Levi Penfield Treadwell (1901 Twin-Lot)',
    posterUrl: '/images/transmissions/nyc/harlem-505-w147-plato-clock-coordinate-505.jpg',
    image: '/images/transmissions/nyc/harlem-505-w147-plato-clock-coordinate-505.jpg',
    source: 'field_transmission',
    createdAt: new Date().toISOString(),
  },
  {
    id: 'event-pianos-dream-pop-festival-2026-10-23',
    city: 'nyc',
    title: "I Have A Dream Pop Festival — The Veldt ('Christine'), Diary, Day & Dream & Darksoft",
    type: 'SHOWCASE',
    date: '2026-10-23T19:00:00-04:00',
    duration: 'Friday, Oct 23, 2026 · 7:00 PM – 1:00 AM',
    venue: 'Pianos',
    venueId: 'venue-pianos-nyc',
    address: '158 Ludlow St, Lower East Side, New York, NY 10002',
    latitude: 40.7208,
    longitude: -73.9886,
    capacity: 150,
    genres: ['Shoegaze', 'Dream Pop', 'Afro-Futurist Soul', 'Post-Punk', 'Lower East Side'],
    description:
      "Friday night of the 'I Have A Dream Pop Festival' at Pianos (158 Ludlow St) founded by identical twin brothers Daniel and Danny Chavis of Afro-futurist soul-shoegaze pioneers The Veldt (opening with 'Christine'), with live Showroom sets by Diary (blood-red vinyl), Day & Dream, and Portland, Maine's Darksoft ('Everydayness').",
    requirements: 'Showroom & Mezzanine stages at Pianos (158 Ludlow St, Lower East Side).',
    compensation: 'I Have A Dream Pop Festival Showcase',
    applicationDeadline: null,
    status: 'PUBLISHED',
    createdBy: 'venue-pianos-nyc',
    featuredArtistName: 'The Veldt, Diary, Day & Dream & Darksoft',
    posterUrl: '/images/transmissions/nyc/pianos-the-veldt-chavis-vox-phantom.jpg',
    image: '/images/transmissions/nyc/pianos-the-veldt-chavis-vox-phantom.jpg',
    source: 'field_transmission',
    createdAt: new Date().toISOString(),
  },
  {
    id: 'event-nomaa-dear-earth-love-uptown-2026-10-22',
    city: 'nyc',
    title: "Dear Earth… Love, Uptown — Opening Reception & Paula Maria Persiani ('Aquí Me Quedo — Los Cepeda')",
    type: 'SHOWCASE',
    date: '2026-10-22T18:00:00-04:00',
    duration: 'Thursday, Oct 22, 2026 · 6:00 PM – 8:00 PM',
    venue: 'NoMAA Gallery (Northern Manhattan Arts Alliance)',
    venueId: 'venue-nomaa-gallery-nyc',
    address: '4140 Broadway (at 176th St), 1st Floor, New York, NY 10033',
    latitude: 40.8471,
    longitude: -73.9383,
    capacity: 150,
    genres: ['Visual Art', 'Nuyorican / Diasporican', 'Loíza Lineage', 'Ecological Sovereignty'],
    description:
      "Opening reception at the Northern Manhattan Arts Alliance (NoMAA) Gallery (4140 Broadway at 176th Street) for 'Dear Earth… Love, Uptown,' featuring 29 artists from West Harlem, Washington Heights, and Inwood and Paula Maria Persiani's 'Aquí Me Quedo — Los Cepeda' (Loíza, Puerto Rico).",
    requirements: 'Open community gallery reception at 4140 Broadway, 1st Floor, Washington Heights.',
    compensation: 'Northern Manhattan Arts Alliance Exhibition',
    applicationDeadline: null,
    status: 'PUBLISHED',
    createdBy: 'venue-nomaa-gallery-nyc',
    featuredArtistName: 'Paula Maria Persiani & 29 Uptown Artists',
    posterUrl: '/images/transmissions/nyc/paula-maria-persiani-aqui-me-quedo-loiza.png',
    image: '/images/transmissions/nyc/paula-maria-persiani-aqui-me-quedo-loiza.png',
    source: 'field_transmission',
    createdAt: new Date().toISOString(),
  },
  {
    id: 'event-film-forum-harlem-2026-10-18',
    city: 'nyc',
    title: "Once Upon A Time in Harlem (Dir. William Greaves, 1972) — The Origin of 'Gig'",
    type: 'SHOWCASE',
    date: '2026-10-18T19:00:00-04:00',
    duration: 'Sunday, Oct 18, 2026 · 7:00 PM – 9:30 PM',
    venue: 'Film Forum',
    venueId: 'venue-film-forum-nyc',
    address: '209 West Houston St, New York, NY 10014',
    latitude: 40.7284,
    longitude: -74.0037,
    capacity: 200,
    genres: ['Harlem Renaissance', 'Documentary Cinema', 'Jazz History', 'Gig Passport Lore'],
    description:
      "Riding the Brooklyn-bound A train from 125th Street down to West 4th Street for Film Forum's screening of William Greaves's 1972 documentary at Duke Ellington's townhouse — featuring Eubie Blake, Noble Sissle, Arna Bontemps, and the 1910 Clef Club origin of the word 'Gig' by James Reese Europe.",
    requirements: 'Ticketed repertory screening at Film Forum (209 West Houston St).',
    compensation: 'Independent Repertory Cinema',
    applicationDeadline: null,
    status: 'PUBLISHED',
    createdBy: 'venue-film-forum-nyc',
    featuredArtistName: 'William Greaves, Eubie Blake, Noble Sissle & James Reese Europe (Archival)',
    posterUrl: '/images/transmissions/nyc/film-forum-once-upon-a-time-in-harlem-marquee.jpg',
    image: '/images/transmissions/nyc/film-forum-once-upon-a-time-in-harlem-marquee.jpg',
    source: 'field_transmission',
    createdAt: new Date().toISOString(),
  },
  {
    id: 'kismat-tuesday-jazz-night',
    city: 'nyc',
    title: 'Tuesday Jazz Night at Kismat — Gottfried Stöger & Uptown Ensemble',
    type: 'RESIDENCY',
    date: daysFromNow(1),
    duration: 'Tuesdays · 8:00 PM – 11:00 PM',
    venue: 'Kismat Washington Heights',
    venueId: 'venue-kismat-washington-heights',
    address: '603 Fort Washington Ave, New York, NY 10033',
    latitude: 40.8548,
    longitude: -73.9358,
    capacity: 80,
    genres: ['Jazz', 'Woodwinds', 'Global Improvisation', 'Washington Heights'],
    description:
      'Weekly Tuesday Jazz Night at Kismat in Washington Heights anchored by resident woodwind master Gottfried Stöger and Uptown improvisors.',
    requirements: 'Open neighborhood jazz session at Kismat (603 Fort Washington Ave).',
    compensation: 'Resident Jazz Night',
    applicationDeadline: null,
    status: 'PUBLISHED',
    createdBy: 'venue-kismat-washington-heights',
    featuredArtistId: 'gottfried-stoger',
    featuredArtistName: 'Gottfried Stöger',
    source: 'venue_schedule',
    createdAt: new Date().toISOString(),
  },
  {
    id: 'kismat-uptown-friday-2026',
    city: 'nyc',
    title: 'Kismat: A Room With a Signal — Weekly Friday Live Music & Karaoke Hosted by Jeremy',
    type: 'SHOWCASE',
    date: daysFromNow(3),
    duration: 'Fridays · 8:30 PM – 11:30 PM (Live Music followed by Karaoke w/ Jeremy)',
    venue: 'Kismat Washington Heights',
    venueId: 'venue-kismat-washington-heights',
    address: '603 Fort Washington Ave, New York, NY 10033',
    latitude: 40.8548,
    longitude: -73.9358,
    capacity: 80,
    genres: ['Live Music', 'Americana', 'Jazz', 'Karaoke', 'Washington Heights'],
    description:
      'NYC Field Transmission No. 1 at Kismat (603 Fort Washington Ave): Jeremy stewards the Washington Heights Cultural Hub & Incubator—where resident performers Gottfried Stöger, Monk Americana, Ed Marshall, Broadway & Lincoln Center players, and neighborhood karaoke regulars converge.',
    requirements: 'Weekly Friday live music & karaoke with Jeremy at 603 Fort Washington Ave.',
    compensation: 'Live Music Night / Free Admission',
    applicationDeadline: null,
    status: 'PUBLISHED',
    createdBy: 'venue-kismat-washington-heights',
    featuredArtistId: 'monk-washington',
    featuredArtistName: 'Jeremy, Gottfried Stöger, Monk Americana & Ed Marshall',
    posterUrl: '/images/kismat_washington_heights_signal.png',
    image: '/images/kismat_washington_heights_signal.png',
    source: 'venue_schedule',
    createdAt: new Date().toISOString(),
  },
  {
    id: 'demo-event-nyc-kismat-1',
    city: 'nyc',
    title: 'Cadré Mulé Live Jazz followed by Karaoke hosted by Jeremy',
    type: 'SHOWCASE',
    date: '2026-09-11T19:00:00-04:00',
    duration: '7:00 PM – 10:00 PM (Live Jazz) followed by Karaoke hosted by Jeremy',
    venue: 'Kismat Washington Heights',
    venueId: 'venue-kismat-washington-heights',
    address: '603 Fort Washington Ave, New York, NY 10033',
    latitude: 40.8548,
    longitude: -73.9358,
    capacity: 80,
    genres: ['Jazz', 'Live Jazz', 'Karaoke', 'Upper Manhattan'],
    description:
      'Live in Upper Manhattan at Kismat Indian: Cadré Mulé featuring Yon Youngman (Piano), Tom Kelly (Saxophones), Andy Pastorino (Drums), and Tim Mulé (Bass) performing live jazz 7:00–10:00 PM, followed by late-night Karaoke hosted by Jeremy.',
    requirements: 'Live jazz set 7–10 PM followed by neighborhood Karaoke hosted by Jeremy.',
    compensation: 'Live Music Night / Free Admission',
    applicationDeadline: null,
    status: 'PUBLISHED',
    createdBy: 'venue-kismat-washington-heights',
    featuredArtistName: 'Cadré Mulé & Jeremy',
    posterUrl: '/images/cadre-mule-kismat-2026-09-11.jpg',
    image: '/images/cadre-mule-kismat-2026-09-11.jpg',
    source: 'venue_flyer',
    createdAt: new Date().toISOString(),
  },
  {
    id: 'demo-event-nyc-pianos-honeychild-monk-2026',
    city: 'nyc',
    title: 'Honeychild Coleman accompanied by Monk Americana',
    type: 'LIVE_SESSION',
    date: '2026-10-24T20:30:00-04:00',
    duration: '8:30 PM',
    venue: 'Pianos (Ludlow St)',
    venueId: 'venue-pianos-nyc',
    address: '158 Ludlow St, New York, NY 10002',
    latitude: 40.7208,
    longitude: -73.9886,
    capacity: 120,
    genres: ['Blues-Punk', 'Americana', 'Indie', 'Lower East Side'],
    description:
      'Honeychild Coleman accompanied by Monk Americana live at Pianos on Ludlow St. An intimate Lower East Side set uniting blues-punk velocity and roots storytelling.',
    requirements: 'Saturday night live session at Pianos (Ludlow St).',
    compensation: 'Live Music Night / Community Cultural Signal',
    applicationDeadline: null,
    status: 'PUBLISHED',
    createdBy: 'venue-pianos-nyc',
    artistId: 'honeychild-coleman',
    featuredArtistId: 'artist-honeychild-coleman',
    featuredArtistName: 'Honeychild Coleman accompanied by Monk Americana',
    source: 'operator',
    createdAt: new Date().toISOString()
  },
  {
    id: 'demo-event-nyc-sistagrrrl-panel-2026',
    city: 'nyc',
    title: 'Sista Grrrl & Riot Grrrl Panel with Honeychild Coleman',
    type: 'PANEL',
    date: '2026-07-22T19:30:00-04:00',
    duration: '7:30 PM',
    venue: 'Melophobe BK',
    venueId: 'venue-melophobe-bk',
    capacity: null,
    genres: [
      'Punk',
      'Black Rock',
      'Riot Grrrl',
      'Sista Grrrl',
      'Cultural History'
    ],
    description:
      'A Brooklyn panel conversation examining Sista Grrrl history, Riot Grrrl, Black women in punk, and the cultural spaces built beyond exclusionary scenes.',
    requirements: 'Attendance details provided by the venue.',
    compensation: 'Community cultural program',
    applicationDeadline: null,
    status: 'PUBLISHED',
    createdBy: 'venue-melophobe-bk',
    featuredArtistId: 'artist-honeychild-coleman',
    source: 'operator',
    createdAt: new Date().toISOString()
  },
  {
    id: 'event-victoria-nyc-sunday-music-thing',
    city: 'nyc',
    title: "Miwi's Music Thing at Victoria NYC — Sunday Songwriter & Catalog Session",
    type: 'RESIDENCY',
    date: daysFromNow(5),
    duration: 'Sundays · 4:30 PM – 7:00 PM',
    venue: 'Victoria NYC',
    venueId: 'venue-victoria-nyc',
    address: '235 Eldridge Street, New York, NY 10002',
    latitude: 40.7226,
    longitude: -73.9902,
    capacity: 60,
    genres: ['Americana', 'Songwriter', 'Catalog Session', 'Field Transmission', 'Lower East Side'],
    description:
      "Weekly Sunday afternoon catalog and songwriter sessions at Victoria NYC on Eldridge Street featuring Miwi La Lupa, Monk Americana, and guest songwriters.",
    requirements: 'Free admission. Sunday afternoon session 4:30–7:00 PM.',
    compensation: 'Resident Showcase / Free Admission',
    applicationDeadline: null,
    status: 'PUBLISHED',
    createdBy: 'venue-victoria-nyc',
    featuredArtistId: 'monk-washington',
    featuredArtistName: 'Miwi La Lupa & Monk Americana',
    source: 'venue_schedule',
    createdAt: new Date().toISOString(),
  },
  {
    id: 'event-taylor-hollingsworth-victoria-nyc-2026-08-23',
    city: 'nyc',
    title: "Miwi's Music Thing with Taylor Hollingsworth",
    type: 'SHOWCASE',
    date: '2026-08-23T16:30:00-04:00',
    duration: 'Event 4:30 PM – 7:00 PM / Taylor at 5:00 PM',
    venue: 'Victoria NYC',
    venueId: 'venue-victoria-nyc',
    address: '235 Eldridge Street, New York, NY',
    latitude: 40.7226,
    longitude: -73.9902,
    capacity: null,
    genres: ["Folk n' Roll", 'Electric Folk', 'Blues', 'Indie'],
    description:
      "Taylor Hollingsworth brings Birmingham folk n' roll to Miwi's Music Thing at Victoria NYC. His featured performance begins at 5:00 PM inside the event's 4:30–7:00 PM program.",
    requirements: 'Free admission. Digital hat contributions support the performers.',
    compensation: 'Free / digital hat',
    applicationDeadline: null,
    status: 'PUBLISHED',
    createdBy: 'venue-victoria-nyc',
    featuredArtistId: 'taylor-hollingsworth',
    featuredArtistName: 'Taylor Hollingsworth',
    venueVerificationStatus: 'unsigned',
    posterUrl: '/images/taylor-hollingsworth-victoria-nyc-2026-08-23.png',
    qrCodeUrl: '/images/taylor-hollingsworth-victoria-nyc-qr.svg',
    qrTargetUrl:
      'https://togeevision.com/scan/taylor-hollingsworth?city=nyc&gigId=event-taylor-hollingsworth-victoria-nyc-2026-08-23&venueId=venue-victoria-nyc&source=artist_qr&campaignId=taylor-victoria-20260823',
    source: 'artist_flyer',
    createdAt: new Date().toISOString(),
  },
  {
    id: 'event-miwi-music-thing-victoria-nyc-2026-09-13',
    city: 'nyc',
    title: "Miwi's Music Thing: Alex Orange Drink Birthday & Catalog Session",
    type: 'SHOWCASE',
    date: '2026-09-13T16:30:00-04:00',
    duration: 'Event 4:30 PM – 7:00 PM / Birthday Session to follow',
    venue: 'Victoria NYC',
    venueId: 'venue-victoria-nyc',
    address: '235 Eldridge Street, New York, NY',
    latitude: 40.7226,
    longitude: -73.9902,
    capacity: null,
    genres: ['Americana', 'Folk-Rock', 'Catalog Session', 'Birthday Set', 'Field Transmission'],
    description:
      "Miwi La Lupa hosts the Sunday Music Thing at Victoria Bar with Conor C Local Elmes and Timothy performing songs from the catalog, joined by special guests Heidemann, Baby Delgado, and Monk Americana (live guest performance uncaptured on tape). Followed by the Alex Orange Drink Birthday Sunday Session. TogeeVision and Anansi Byte perform live audio/video field capture for the station archive.",
    requirements: 'Open admission. Live catalog set, birthday celebration, and TogeeVision/Anansi field capture.',
    compensation: 'Free admission / digital hat',
    applicationDeadline: null,
    status: 'PUBLISHED',
    createdBy: 'venue-victoria-nyc',
    featuredArtistId: null,
    featuredArtistName: 'Miwi La Lupa, Conor Elmes & Monk Americana',
    venueVerificationStatus: 'unsigned',
    source: 'field_transmission',
    posterUrl: '/images/miwi-music-thing-victoria-nyc-2026-09-13.jpg',
    createdAt: new Date().toISOString(),
  },
  // ── Bethlehem / Musikfest events ──
  {
    id: 'demo-event-lv-1',
    city: 'lehigh_valley',
    title: 'Musikfest Jazz Showcase — SteelStacks',
    type: 'SHOWCASE',
    date: daysFromNow(3),
    duration: '7:00 PM – 11:00 PM',
    venue: 'SteelStacks',
    capacity: 1500,
    genres: ['Big Band', 'Swing', 'Be-Bop'],
    description: 'Special festival showcase featuring the Signal All-Stars and local legends. Held at the iconic SteelStacks outdoor stage.',
    requirements: 'Musikfest credentials or ticket required.',
    compensation: 'Tiered performance shares',
    applicationDeadline: daysFromNow(1),
    status: 'PUBLISHED',
    createdBy: 'venue-steelstacks',
    createdAt: new Date().toISOString(),
  },
  {
    id: 'demo-event-lv-2',
    city: 'lehigh_valley',
    title: 'Historic Bethlehem Open Air Residency',
    type: 'RESIDENCY',
    date: daysFromNow(5),
    duration: '12:00 PM – 6:00 PM',
    venue: 'Musikfest',
    capacity: 5000,
    genres: ['Jazz Fusion', 'Blues', 'Funk'],
    description: 'Daytime residency curated by the Black Star Signal. Multiple stages across the historic north side.',
    requirements: 'Looking for high-energy jazz and soul acts.',
    compensation: '$500 guarantee',
    applicationDeadline: daysFromNow(3),
    status: 'PUBLISHED',
    createdBy: 'fan-miriam-cote',
    createdAt: new Date().toISOString(),
  },
  {
    id: 'demo-event-lv-3',
    city: 'lehigh_valley',
    title: 'Wind Creek Late Night Session',
    type: 'SHOWCASE',
    date: daysFromNow(9),
    duration: '10:00 PM – 1:00 AM',
    venue: 'Wind Creek Event Center',
    capacity: 2500,
    genres: ['Jazz-Pop', 'Smooth Jazz', 'Vocal Jazz'],
    description: 'Premium late-night event featuring special guests from the festival circuit.',
    requirements: 'Submit press kit via Gig Passport for consideration.',
    compensation: '$1200 + accommodation',
    applicationDeadline: daysFromNow(6),
    status: 'PUBLISHED',
    createdBy: 'venue-wind-creek',
    createdAt: new Date().toISOString(),
  },
  // ── Rochester Fringe events ──
  {
    id: 'event-the-church-mister-aubs-rochester-2026',
    city: 'rochester',
    title: 'Mister Aubs Live at The Church (Downtown United Presbyterian Church: Hallock Lounge)',
    type: 'SHOWCASE',
    date: '2026-09-24T19:00:00-04:00',
    duration: 'Thursday, Sep 24, 2026 · 7:00 PM – 8:00 PM',
    venue: 'The Church (Downtown United Presbyterian Church: Hallock Lounge)',
    venueId: 'venue-the-church-rochester',
    address: '121 N Fitzhugh St, Rochester, NY 14614',
    latitude: 43.1565,
    longitude: -77.6125,
    featuredArtistId: 'artist-mister-aubs',
    featuredArtistName: 'Mister Aubs',
    capacity: 200,
    genres: ['Rochester Fringe', 'Live Trio', 'Grand Piano Songcraft', 'Soul & Vocal'],
    description: 'Rochester Fringe Festival live performance by Mister Aubs and his collaborator trio (DK Keys & Anthony A.C. Collins) in the Hallock Lounge at The Church (Downtown United Presbyterian Church, 121 N Fitzhugh St) on Thursday, September 24, 2026.',
    requirements: 'Rochester Fringe Festival Hallock Lounge performance.',
    compensation: 'Rochester Fringe official program',
    applicationDeadline: null,
    status: 'PUBLISHED',
    createdBy: 'venue-the-church-rochester',
    createdAt: '2026-09-24T19:00:00-04:00',
  },
  // ── Rototom events ──
  {
    id: 'demo-event-rtm-1',
    city: 'rtm',
    title: 'Yetibeb Moged Show & Reggae Review',
    type: 'SHOWCASE',
    date: daysFromNow(2),
    duration: '6:00 PM – 10:00 PM',
    venue: 'House of Rastafari Stage',
    capacity: 2000,
    genres: ['Roots Reggae', 'Reggae', 'Cultural Documentation'],
    description: 'Cultural hub showcase featuring Yetibeb Moged and local roots bands. Spiritual lineage and live dub sessions.',
    requirements: 'Valid Rototom Sunsplash wristband required.',
    compensation: 'Performance fee + recording archive',
    applicationDeadline: daysFromNow(1),
    status: 'PUBLISHED',
    createdBy: 'artist-girum',
    createdAt: new Date().toISOString(),
  },
  {
    id: 'demo-event-rtm-2',
    city: 'rtm',
    title: 'Yetibeb Moged Live Dub Session',
    type: 'SHOWCASE',
    date: daysFromNow(4),
    duration: '8:00 PM – 11:30 PM',
    venue: 'House of Rastafari Stage',
    capacity: 500,
    genres: ['Roots Reggae', 'Dub', 'Sound System'],
    description: 'A live dub session mixed on the 16-channel analog desk with space echo delay. Dubplates and exclusive cuts.',
    requirements: 'Open session.',
    compensation: 'Performance fee',
    applicationDeadline: daysFromNow(3),
    status: 'PUBLISHED',
    createdBy: 'artist-yetibeb',
    createdAt: new Date().toISOString(),
  },
  {
    id: 'demo-event-rtm-3',
    city: 'rtm',
    title: 'Roots Drumming Workshop & Culture Circle',
    type: 'WORKSHOP',
    date: daysFromNow(5),
    duration: '2:00 PM – 4:30 PM',
    venue: 'House of Rastafari Pavilion',
    capacity: 100,
    genres: ['Nyabinghi Drumming', 'Roots', 'Cultural Documentation'],
    description: 'Daily workshop documenting the roots corridor between Spain and Ethiopia. Open to all volunteers.',
    requirements: 'Bring your own drums or use the provided ones.',
    compensation: 'Complimentary',
    applicationDeadline: daysFromNow(4),
    status: 'PUBLISHED',
    createdBy: 'venue-house-of-rastafari',
    createdAt: new Date().toISOString(),
  },
];

/**
 * Known venues, longest name first so a venue cannot be claimed by a shorter one
 * that happens to share its opening words.
 */
const VENUE_IDENTITIES = (PERSONAS_BY_ROLE['Venue Owner'] || [])
  .map(({ id, city, name }) => ({ id, city, name }))
  .sort((a, b) => b.name.length - a.name.length);

/**
 * Recover a venue's canonical id from the name an event carries.
 *
 * Event venues are often a room within a venue — "House of Rastafari Stage",
 * "House of Rastafari Pavilion" — so an exact match is not enough. Matching a
 * name followed by a space keeps "SteelStacks Amphitheater" resolving to
 * SteelStacks without letting an unrelated "SteelStacksville" through, and the
 * city check stops venues that share a name across regions from colliding.
 */
const resolveKnownVenueId = (venueName, cityId) => {
  if (!venueName) return null;
  const match = VENUE_IDENTITIES.find(
    (venue) => venue.city === cityId
      && (venueName === venue.name || venueName.startsWith(`${venue.name} `)),
  );
  return match ? match.id : null;
};

export const DEMO_EVENTS = RAW_DEMO_EVENTS.map(event => {
  const cityId = event.city === 'lehigh_valley' || event.city === 'lvpa' ? 'lehigh_valley' : event.city;
  
  const artistId =
    event.featuredArtistId ||
    (event.createdBy?.startsWith('artist-')
      ? event.createdBy
      : null);

  const ARTIST_NAMES = {
    'monk-washington': 'Monk Americana',
    'monk-americana': 'Monk Americana',
    'gottfried-stoger': 'Gottfried Stöger',
    'artist-gottfried-stoger': 'Gottfried Stöger',
    'ed-marshall': 'Ed Marshall',
    'artist-ed-marshall': 'Ed Marshall',
    'anansi-byte': 'Anansi Byte',
    'artist-anansi-byte': 'Anansi Byte',
    'artist-girum': 'Girum',
    'artist-yetibeb': 'Yetibeb',
    'honeychild-coleman': 'Honeychild Coleman',
    'artist-honeychild-coleman': 'Honeychild Coleman',
    'taylor-hollingsworth': 'Taylor Hollingsworth',
    'azariah': 'Azariah (Darius Franklin)',
    'artist-azariah': 'Azariah (Darius Franklin)',
    'artist-mister-aubs': 'Mister Aubs',
  };

  const artistName =
    ARTIST_NAMES[artistId] ||
    event.featuredArtistName ||
    'Guest Artist';

  // A venue keeps its identity even when an artist or operator created the
  // event; falling straight through to 'venue-generic' lost the association and
  // with it the venue's chronicle and profile links.
  const venueId = event.venueId
    || (event.createdBy?.startsWith('venue-') ? event.createdBy : null)
    || resolveKnownVenueId(event.venue, cityId)
    || 'venue-generic';
  const signalStatus = event.id.includes('mtl-1') || event.id.includes('nyc-1') || event.id.includes('lv-1') || event.id.includes('kismat-1')
    ? 'live' 
    : 'seeded';
  
  return {
    ...event,
    cityId,
    artistId,
    artistName,
    venueId,
    venueName: event.venue,
    startsAt: event.date,
    signalStatus,
    fanCheckInCount: signalStatus === 'live' ? 14 : 0,
    passportStampCount: signalStatus === 'live' ? 22 : 0,
    radarWeight: signalStatus === 'live' ? 2.5 : 1.0,
    source: event.createdBy?.startsWith('artist-') ? 'artist_created' : event.createdBy?.startsWith('venue-') ? 'venue_created' : 'operator_seeded'
  };
});

export const FIELD_TRANSMISSIONS = [
  {
    id: 'lehigh-valley-musikfest',
    city: 'lehigh_valley',
    eyebrow: 'LEHIGH VALLEY FIELD TRANSMISSION',
    title: 'Lehigh Valley / Musikfest',
    description:
      'Triggers a regional radar loop: Artists establish profiles to attract fans, each Musikfest gig adds a node to the Signal Radar, and verified fan check-ins at SteelStacks generate valuable scene intelligence.',
    image: '/images/trexlertown_velodrome_signal.jpg',
    imageAlt: 'Lehigh Valley Musikfest field signal',
    color: '#D37633', // Brand orange
    actionLabel: 'Open Lehigh Valley Signal',
    to: '/lehigh-valley',
    chips: ['Regional radar', 'Musikfest nodes', 'SteelStacks check-ins'],
  },
  {
    id: 'montreal-jazz',
    city: 'montreal',
    eyebrow: 'MONTREAL FIELD TRANSMISSION NO. 1',
    title: 'Montreal Jazz Festival',
    description:
      'Montreal is the first live field test for TogeeVision: pirate jazz radio, Signal Radar, QR cards, and collaborator outreach turning a cultural moment into stories, tools, and relationships.',
    image: '/images/hudson_valley_nexus.jpg',
    imageAlt: 'Montreal Jazz abstract field transmission',
    color: '#E2A6FF',
    actionLabel: 'See the Montreal Brief',
    to: '/montreal-jazz-dossier',
    chips: ['Festival field test', 'Signal Radar', 'QR cards'],
  },
  {
    id: 'nyc-downtown-uptown-circuit',
    city: 'nyc',
    eyebrow: 'NYC FIELD TRANSMISSION',
    title: 'NYC / Downtown & Uptown Circuit',
    description:
      "A city-scoped cultural radar connecting Pianos NYC ('I Have A Dream Pop Festival' with Honeychild Coleman's DEM, Monk Americana, and The Veldt), Victoria NYC, NoMAA Gallery, and uptown rooms.",
    image: '/images/transmissions/nyc/pianos-the-veldt-chavis-vox-phantom.jpg',
    imageAlt: 'New York City field signal',
    color: '#38bdf8',
    actionLabel: 'Open NYC Signal',
    to: '/passport/transmissions/venue-pianos-nyc',
    chips: ['Pianos NYC', 'Venue profiles', 'Artist profiles'],
  },
  {
    id: 'rochester-fringe-signal',
    city: 'rochester',
    eyebrow: 'ROCHESTER FIELD TRANSMISSION',
    title: 'Rochester Fringe & Hallock Lounge (The Church)',
    description:
      'Tracing the Rochester Fringe Festival corridor from Hallock Lounge (The Church) to Water Street Music Hall and the Genesee creative circuit.',
    image: '/images/03_rochester.jpg',
    imageAlt: 'Rochester Fringe field signal',
    color: '#f43f5e',
    actionLabel: 'Open Rochester Signal',
    to: '/passport/transmissions/venue-hallock-lounge-rochester',
    chips: ['Rochester Fringe', 'Hallock Lounge', 'Water Street'],
  },
  {
    id: 'birmingham-the-nick-signal',
    city: 'birmingham',
    eyebrow: 'BIRMINGHAM FIELD TRANSMISSION',
    title: "The Nick Birmingham — Folk N' Roll Grid",
    description:
      "Archiving Birmingham's late-night rock sanctuary on 10th Avenue South alongside Saturn and the Deep South independent touring circuit.",
    image: '/images/transmissions/birmingham/the-nick-stage.jpg',
    imageAlt: 'The Nick Birmingham field signal',
    color: '#D37633',
    actionLabel: 'Open Birmingham Signal',
    to: '/passport/transmissions/venue-the-nick-birmingham',
    chips: ['The Nick', 'Saturn Birmingham', 'Deep South Corridor'],
  },
  {
    id: 'laurentian-borderlands',
    city: 'laurentian',
    eyebrow: 'REGIONAL FIELD TRANSMISSION NO. 005',
    title: 'Laurentian Borderlands',
    description:
      'A region for captured ephemera: tracing cultural wires across rural New Jersey, upstate Jamestown, NY, and the boreal landscapes of Quebec without full venue or artist profiles.',
    image: '/images/laurentian_borderlands.jpg',
    imageAlt: 'Laurentian Borderlands captured ephemera',
    color: '#10b981',
    actionLabel: 'Open Laurentian Signal',
    to: '/laurentian',
    chips: ['Captured ephemera', 'Signal check', 'Boreal frequencies'],
  },
  {
    id: 'rototom-sunsplash-rtm',
    city: 'rtm',
    eyebrow: 'ROTOTOM FIELD TRANSMISSION NO. 1',
    title: 'Rototom Sunsplash',
    description:
      'Yetibeb Moged Show and Rototom coverage under his stewardship, bridging Spain and Ethiopia with custom Field Passports and QR redirect infrastructure.',
    image: '/images/rototom_main_stage.jpg',
    imageAlt: 'Rototom Sunsplash field transmission',
    color: '#10B981',
    actionLabel: 'Open Rototom Signal',
    to: '/rototom',
    chips: ['House of Rastafari', 'Spain-Ethiopia Corridor', 'Yetibeb Moged'],
  },
];
